import { cn } from "~/services/shadcn";

export const ComingSoonOverlay = ({ className }: { className?: string }) => (
  <div
    className={cn(
      "absolute inset-0 z-30 flex cursor-not-allowed items-center justify-center bg-black/30 backdrop-blur-sm max-md:border max-md:border-border",
      className,
    )}
  >
    <div className=" px-8 py-4 text-lg font-medium">Coming soon...</div>
  </div>
);
